import { TableViewStore, BaseListViewStore } from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import { LocalDoctorService } from 'application/import/services';
import { resolveColumns } from 'application/facility/util/resolveColumns';
import {GridBooleanCell} from 'core/components';

@applicationContext
class NikoOrderingDoctorListViewStore extends BaseListViewStore {
    constructor(rootStore) {
        const service = new LocalDoctorService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'niko-ordering-doctor',
            autoInit: true,
            authorization: {
                create: 'portalSection.create',
                delete: 'portalSection.delete',
            },
            routes: {
            },
            actions: () => {
                return {
                    find: async (params) => {
                        const response = await service.find({  ...params, isNiko: true });
                        return response.data;
                    }
                }
            }
        });

        this.sync = async () => {
            this.loaderStore.suspend();
            this.tableStore.suspend();
            try {
                await service.nikoSync();
                await this.queryUtility.fetch();
                this.rootStore.notificationStore.success("Sync successfully done.");
            } catch (err) {
                this.rootStore.notificationStore.error(err && err.data && err.data.errors ? err.data.errors : 'Error occurred while trying to sync insurances.');
            }
            this.tableStore.resume();
            this.loaderStore.resume();
        };

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: resolveColumns([
                {
                    key: 'name',
                    title: 'ORDERING_DOCTOR.LIST.COLUMNS.NAME',
                },
                 {
                    key: 'npi',
                    title: 'ORDERING_DOCTOR.LIST.COLUMNS.NPI',
                    width: 200
                },
                {
                    key: 'primaryAddressState',
                    title: 'State',
                    width: 200
                },
                {
                    key: 'pecosEnrollment',
                    title: 'PECOS Enrollment',
                    cell: GridBooleanCell,
                    displayFaultyValue: true,
                    width: 200,
                    headerClassName: 'center'
                }
            ]),
            actions: {
            }
        }));
    }
}

export default NikoOrderingDoctorListViewStore;
